import type { Builder } from "../../types.js";
import { buildHierarchyEndpoints } from "./hierarchyEndpoints.js";

export const buildProductEndpoints = (builder: Builder) => ({
	...buildHierarchyEndpoints(builder),
});
